module.exports = require("@pb/kit-component-field-description");